import type { WorkshopId } from "../../../../api/workshop";
import { useStorageState } from "../../../../lib/storage";

const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

export function useLernreiseCompletionCheck(
  workshopId: WorkshopId | undefined,
) {
  const [lastChecked, setLastChecked, { clear }] = useStorageState<number>(
    `lastTimeLernreiseStateChecked-${workshopId}`,
  );

  return {
    isDueNow: () =>
      typeof lastChecked !== "number" ||
      Date.now() - lastChecked >= ONE_DAY_IN_MS,
    markChecked: () => setLastChecked(Date.now()),
    clearCheck: clear,
  };
}
